<template>
  <h2 class="font-poppins text-[1.25rem] font-extrabold capitalize text-metallic-violet dark:text-gray-100">
    <slot></slot>
  </h2>
</template>
